<template>
  <v-container fluid grid-list-sm>
    <v-card>
      <v-toolbar flat class="card-header">
        <v-btn icon exact :to="{name: 'users'}"><v-icon>clear</v-icon></v-btn>
        <span class="title">Edit User</span>
        <v-spacer></v-spacer>
        <v-btn @click="showDeleteDialog = true" depressed dark color="error">Remove User</v-btn>
      </v-toolbar>
      <v-container grid-list-sm>
        <v-layout row wrap>
          <v-flex xs12 sm4>
            <v-text-field
            v-model="item.nameDisplay"
            label="Name"
            disabled
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
            v-model="item.email"
            label="Email"
            disabled
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-select
            :value="userRoleGet(item.memberships, selectedSite._id).role"
            :items="roles"
            item-text="name"
            item-value="value"
            label="Name"
            @change="roleChange"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <v-dialog v-model="showDeleteDialog" max-width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Delete Item</v-card-title>
        <v-card-text class="pt-4">
          Are you sure you want to remove the user "{{ item.nameDisplay }}" ({{item.email}}) from this site?
          If you change your mind, you can invite them to join again later.
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="deleteUser">I'm sure</v-btn>
          <v-btn text @click="showDeleteDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <error-snackbar v-model="errorText"></error-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

import ApiRequests from '@/api/ApiRequests'
import { AuthMixins } from '@/shared/mixins'
import ErrorSnackbar from '@/components/ErrorSnackbar'

export default {
  components: {
    ErrorSnackbar
  },

  mixins: [AuthMixins],

  data () {
    return {
      errorText: '',
      item: {},
      loading: false,
      showDeleteDialog: false
    }
  },

  created () {
    this.getItem()
  },

  computed: {
    ...mapGetters([
      'selectedSite',
      'isSiteSelected'
    ])
  },

  methods: {
    getItem: function () {
      if (this.isNew) return

      this.loading = true
      ApiRequests.userGet(this.$route.params.id).then(r => {
        this.item = r.data
        this.loading = false
      }).catch(e => {
        this.errorText = 'Error getting user: ' + e.response.data
      })
    },

    roleChange: function (x) {
      var body = {
        role: x
      }
      ApiRequests.siteUserUpdate(this.selectedSite._id, this.item._id, body).then(r => {
        this.errorText = 'User Role Updated'
        this.exit()
      }).catch(e => {
        this.errorText = 'Error updating user role: ' + e.response.data
      })
    },

    deleteUser: function () {
      ApiRequests.siteUserRemove(this.selectedSite._id, this.item._id).then(r => {
        this.exit()
      }).catch(e => {
        this.errorText = 'Error removing user from site: ' + e.response.data
      })
    },

    exit: function () {
      this.$router.push({ name: 'users' })
    }
  }
}
</script>
